import React, { useEffect } from 'react';
import { Container, Navbar, Breadcrumb, Row, Col, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { getNotaCobro } from '../../redux/notacobroSlice';
import { consumoHistorico } from '../../redux/consumoHistoricoSlice';
import { pintaNumero } from '../../libreria/utilidades';
import NotaCobro from './NotaCobro';
import GraficoConsumo from '../documentos/GraficoConsumo';
import SearchIcon from '@mui/icons-material/Search';
import SearchById from '../../componentes/SearchById';
import LoaderSpinner from '../../libreria/LoaderSpinner';
import CardPlaceHolder from '../../componentes/CardPlaceHolder';
import WarningMessage from '../../componentes/WarningMessage';
import './NotaCobroFolio.css';

function NotaCobroFolio() {
  const { folio } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { promiseInProgress: notacobroInProgress } = usePromiseTracker({ area: 'area-notacobro', delay: 0 });
  const { promiseInProgress: graficoInProgress } = usePromiseTracker({ area: 'area-grafico', delay: 0 });
  const comunidad = useSelector((store) => store.comunidad);
  const notacobro = useSelector((store) => store.notacobro);

  function handleNotaCobroSearch(value) {
    navigate(`/notacobro/folio/${Number(value)}`);
  }

  function handleSelectCodServicioOpcion(eventKey) {
    if (notacobro.cabecera) {
      if (eventKey === 'notascobro') {
        navigate(`/notacobro/cod-servicio/${notacobro.cabecera.codigo_servicio}`);
      } else if (eventKey === 'cta-cte') {
        navigate(`/pago/cta-cte/${notacobro.cabecera.codigo_servicio}`);
      }
    }
  }

  useEffect(() => {
    const onRender = () => {
      trackPromise(dispatch(getNotaCobro(comunidad.selected.id, folio)), 'area-notacobro');
      trackPromise(dispatch(consumoHistorico(comunidad.selected.id, folio, '_NOTA_COBRO')), 'area-grafico');
    };

    onRender();
  }, [comunidad.selected, folio]);

  function pintaCodigoServicio() {
    return notacobroInProgress || notacobro.cabecera === null ? '' : pintaNumero(notacobro.cabecera.codigo_servicio);
  }

  function LoaderSpinnerPlaceHolder() {
    return (
      <LoaderSpinner isLoading={true}>
        <CardPlaceHolder />
      </LoaderSpinner>
    );
  }

  return (
    <>
      <Container fluid className='NotaCobroFolio d-flex flex-wrap p-0 shadow-sm'>
        <Navbar bg='white' className='flex-fill border-bottom altura-navbar'>
          <Container fluid className='ms-4'>
            <Breadcrumb className='h4 fw-bold m-0' listProps={{ className: 'm-0' }}>
              <Breadcrumb.Item active className='d-none d-md-inline text-secondary'>
                Gestión del servicio
              </Breadcrumb.Item>
              <li className='breadcrumb-item d-none d-lg-inline text-primary'>
                <Link to='/notacobro' className='text-decoration-none'>
                  Notas de cobro
                </Link>
              </li>
              <Breadcrumb.Item active>Nota de cobro {folio}</Breadcrumb.Item>
            </Breadcrumb>
          </Container>
        </Navbar>
      </Container>
      <Container fluid className='PanelNotasCobro d-flex flex-wrap p-0 shadow-sm'>
        <Navbar bg='warning' className='flex-fill border-bottom altura-navbar'>
          <SearchIcon className='icono-centrado ms-3' />
          <i className='ms-1 fw-bold fst-normal me-1 d-none d-md-inline'>Búsqueda</i>
          <div className='vr mx-2'></div>
          <SearchById className='me-2' placeholder='Folio n.cobr.' btntext='Buscar' onClick={handleNotaCobroSearch} />
          <div className='vr mx-2'></div>
          <Dropdown onSelect={handleSelectCodServicioOpcion}>
            <Dropdown.Toggle variant='outline-secondary' size='sm' id='dropdown-cod-servicio'>
              Código servicio: <i className='fst-normal fw-bold'>{pintaCodigoServicio()}</i>
            </Dropdown.Toggle>
            <Dropdown.Menu className='dropdown-menu-end'>
              <Dropdown.Item eventKey='notascobro'>Ver otras notas de cobro</Dropdown.Item>
              <Dropdown.Item eventKey='cta-cte'>Ver cuenta corriente</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Navbar>
      </Container>

      <Container fluid>
        {notacobroInProgress || graficoInProgress ? (
          <Row className='p-2'>
            <Col xs={12} md={12} lg={7} xl={6} className='p-2'>
              <LoaderSpinnerPlaceHolder />
            </Col>
            <Col xs={12} md={10} lg={5} xl={4} className='p-2'>
              <LoaderSpinnerPlaceHolder />
            </Col>
          </Row>
        ) : notacobro.cabecera ? (
          <Row className='p-2'>
            <Col xs={12} md={12} lg={7} xl={6} className='p-2'>
              <NotaCobro />
            </Col>
            <Col xs={12} md={10} lg={5} xl={4} className='p-2'>
              <GraficoConsumo />
            </Col>
          </Row>
        ) : (
          <Row className='p-2'>
            <Col xs={12} md={12} className='p-2'>
              <WarningMessage>No se ha encontrado nota de cobro.</WarningMessage>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
}

export default NotaCobroFolio;
